import { Sparkles } from 'lucide-react';
import { useAgentName } from '../agent-name';
import { Tooltip, TooltipContent, TooltipTrigger } from '../components/ui/tooltip';
import './ask-about.css';

/** Opens the chat (⌘J) pinned to one customer, from any page; the shell listens for this event. */
export interface AskAboutDetail { customerId: string; prefill?: string }
export const askEvent = 'alder:ask';
export function askAbout(detail: AskAboutDetail) {
  window.dispatchEvent(new CustomEvent<AskAboutDetail>(askEvent, { detail }));
}

/**
 * "Tell Amy about this customer" beside a row: a quiet button that shows on hover or focus and opens the chat scoped to
 * that customer, where a person can ask about the account or tell her something to remember.
 */
export function AskAbout({ customerId, name }: { customerId: string; name: string }) {
  const agent = useAgentName();
  const label = `Ask or tell ${agent} about ${name}`;
  return <Tooltip><TooltipTrigger asChild>
    <button type="button" className="ask-about" aria-label={label}
      onClick={event => { event.stopPropagation(); askAbout({ customerId }); }}>
      <Sparkles size={13} aria-hidden /></button>
  </TooltipTrigger><TooltipContent>{label}</TooltipContent></Tooltip>;
}
